import { Search } from 'lucide-react';
import { useTranslation } from '@bms/common';
import { Kbd } from '@bms/common/ui';
import { Button } from '@/components/ui/button';
import { openDeskSearch } from './deskSearchStore';

function isMac(): boolean {
  return typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform ?? '');
}

/**
 * The header's way into the desk palette (P1): a field from `md` up — typing
 * in it opens the palette with the text, a click or ↵/↓ opens it empty — and
 * an icon button below `md`, where the header has room for nothing wider.
 */
export function DeskSearchField() {
  const { t } = useTranslation();
  return (
    <>
      <div className="relative hidden w-56 md:block lg:w-64">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" aria-hidden="true" />
        <input
          type="search"
          value=""
          aria-label={t('search.fieldAria')}
          aria-haspopup="dialog"
          placeholder={t('search.placeholder')}
          autoComplete="off"
          onChange={(event) => { if (event.target.value) openDeskSearch({ query: event.target.value }); }}
          onClick={() => openDeskSearch()}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === 'ArrowDown') {
              event.preventDefault();
              openDeskSearch();
            }
          }}
          className="h-8 w-full rounded-md border border-input bg-transparent pl-8 pr-14 text-ui placeholder:text-muted-foreground outline-none hover:border-input-hover focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50"
        />
        <Kbd className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2">
          {isMac() ? t('search.shortcutMac') : t('search.shortcut')}
        </Kbd>
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7 text-muted-foreground md:hidden"
        onClick={() => openDeskSearch()}
        aria-label={t('search.openAria')}
      >
        <Search className="h-4 w-4" />
      </Button>
    </>
  );
}
